import { render, staticRenderFns } from "./SportWatchNowButton.vue?vue&type=template&id=f6979b66&scoped=true"
import script from "./SportWatchNowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportWatchNowButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportWatchNowButton.vue?vue&type=style&index=0&id=f6979b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6979b66",
  null
  
)

export default component.exports